var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrassAndTrees(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19200 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7698 1003H9618V1222H7698V1003Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8352,
    y: 1025,
    width: 58,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8206,
    y: 1051,
    width: 34,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8224,
    y: 1044,
    width: 58,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8529,
    y: 1063,
    width: 58,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8568,
    y: 1075,
    width: 58,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8909,
    y: 1039,
    width: 39,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8938,
    y: 1027,
    width: 39,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9912 961H11832V1180H9912V961Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10566,
    y: 983,
    width: 58,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10420,
    y: 1009,
    width: 34,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10438,
    y: 1002,
    width: 58,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10743,
    y: 1021,
    width: 58,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10782,
    y: 1033,
    width: 58,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11123,
    y: 997,
    width: 39,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11152,
    y: 985,
    width: 39,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15307 1046H17243V1216H15307V1046Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15966.4,
    y: 1063.08,
    width: 58.4833,
    height: 1.55251,
    rx: 0.776256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15383.6,
    y: 1077.83,
    width: 58.4833,
    height: 1.55251,
    rx: 0.776256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16528.1,
    y: 1073.95,
    width: 39.325,
    height: 1.55251,
    rx: 0.776256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16900.2,
    y: 1064.63,
    width: 39.325,
    height: 1.55251,
    rx: 0.776256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9599.5 496C9515.33 481.898 9468.16 537.562 9445.02 546.039C9435.13 549.657 9428.42 553.037 9426.6 553.961C9381.8 576.777 9361.51 614.591 9345.01 641.103C9301.37 711.213 9292.26 689.269 9244.99 762.574C9200.88 830.994 9202.91 859.249 9163.4 881.405C9146.71 890.753 9147.24 885.207 9089.7 907.811C9033.72 929.782 9018.93 940.661 9010.74 947.422C8987.69 966.487 8974.08 988.748 8966 1005.52C9176.56 1002.88 9387.12 1000.24 9597.68 997.595H9602.94L9599.5 496Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11464 376.875C11357.7 359.068 11298.2 429.363 11268.9 440.068C11256.4 444.637 11248 448.905 11245.7 450.072C11189.1 478.885 11163.5 526.639 11142.6 560.121C11087.5 648.659 11076 620.947 11016.3 713.521C10960.6 799.925 10963.2 835.607 10913.3 863.586C10892.2 875.391 10892.9 868.389 10820.2 896.934C10749.5 924.68 10730.8 938.419 10720.5 946.956C10691.4 971.033 10674.7 993.324 10664.5 1014.5C10930.4 1011.17 11195.8 1013.65 11461.7 1010.32H11468.4L11464 376.875Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11463.3 376.875C11569.6 359.068 11629.2 429.363 11658.4 440.068C11670.9 444.637 11679.4 448.905 11681.7 450.072C11738.3 478.885 11763.9 526.639 11784.7 560.121C11839.8 648.659 11851.3 620.947 11911 713.521C11966.7 799.925 11964.2 835.607 12014.1 863.586C12035.2 875.391 12034.5 868.389 12107.1 896.934C12177.8 924.68 12196.5 938.419 12206.9 946.956C12236 971.033 12253.2 999.146 12263.4 1020.32C11997.5 1016.99 11731.6 1013.65 11465.6 1010.32H11459L11463.3 376.875Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9597.45 496.277C9681.62 482.176 9728.79 537.84 9751.92 546.316C9761.82 549.934 9768.53 553.314 9770.35 554.238C9815.14 577.054 9835.43 614.868 9851.94 641.381C9895.58 711.491 9904.68 689.546 9951.95 762.852C9996.07 831.271 9994.04 859.527 10033.5 881.682C10050.2 891.03 10049.7 885.485 10107.2 908.089C10163.2 930.059 10178 940.939 10186.2 947.699C10209.3 966.765 10222.9 989.026 10230.9 1005.79C10020.4 1003.15 9809.83 1000.51 9599.27 997.872H9594L9597.45 496.277Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9599.94 994.597C9599.94 994.597 9599.94 748.142 9599.94 624.902C9594.91 624.559 9586.2 624.453 9576.25 627.543C9561.41 632.164 9552.14 641.301 9549.93 643.387C9528.85 663.271 9473.34 678.085 9426.23 701.482C9395.8 716.586 9290.29 769.004 9273.57 836.156C9271.49 844.527 9266.76 869.27 9249.88 875.766C9238.07 880.308 9231.43 871.62 9218.3 875.766C9202.3 880.81 9200.32 897.42 9184.08 918.017C9184.08 918.017 9167.58 938.958 9141.97 952.346C9108.41 969.906 9090.49 956.888 9052.48 970.831C9039.51 975.584 9021.61 984.456 9002.48 1002.52L9599.94 994.597Z",
    fill: "#0A0019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11463.5 1009.07C11463.5 1009.07 11463.5 715.166 11463.5 568.2C11457.5 567.791 11447.1 567.665 11435.2 571.349C11417.5 576.86 11406.5 587.756 11403.8 590.244C11378.7 613.956 11312.5 631.622 11256.3 659.522C11220 677.535 11094.2 740.043 11074.3 820.124C11071.8 830.106 11066.2 859.613 11046 867.359C11031.9 872.776 11024 862.415 11008.4 867.359C10989.3 873.374 10986.9 893.181 10967.6 917.744C10967.6 917.744 10947.9 942.716 10917.4 958.681C10877.3 979.623 10856 964.098 10810.6 980.725C10795.2 986.393 10770.8 991.961 10748 1013.5L11463.5 1009.07Z",
    fill: "#0A0019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11463.9 1002.07C11463.9 1002.07 11463.9 708.166 11463.9 561.2C11469.9 560.791 11480.3 560.665 11492.1 564.349C11509.8 569.86 11520.9 580.756 11523.5 583.244C11548.7 606.956 11614.9 624.622 11671 652.522C11707.3 670.535 11833.2 733.043 11853.1 813.124C11855.6 823.106 11861.2 852.613 11881.3 860.359C11895.4 865.776 11903.3 855.415 11919 860.359C11938.1 866.374 11940.4 886.181 11959.8 910.744C11959.8 910.744 11979.5 935.716 12010 951.681C12050 972.623 12071.4 957.098 12116.7 973.725C12132.2 979.393 12153.5 989.974 12176.4 1011.51L11463.9 1002.07Z",
    fill: "#0A0019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9597 997.874C9597 997.874 9597 751.42 9597 628.18C9602.03 627.836 9610.74 627.731 9620.69 630.82C9635.54 635.441 9644.8 644.578 9647.01 646.664C9668.1 666.549 9723.6 681.363 9770.72 704.759C9801.14 719.864 9906.66 772.281 9923.37 839.434C9925.45 847.804 9930.19 872.548 9947.06 879.044C9958.88 883.586 9965.51 874.898 9978.64 879.044C9994.65 884.087 9996.62 900.697 10012.9 921.294C10012.9 921.294 10029.4 942.235 10055 955.623C10088.5 973.184 10106.5 960.165 10144.5 974.108C10157.4 978.861 10177.9 987.438 10197 1005.5L9597 997.874Z",
    fill: "#0A0019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11887 993.5C11958 981.001 12111.3 980.137 12228 993.5C12311 1003 12478 1002.5 12568 993.5C12655 984.806 12678.5 979.501 12808.5 961.501C12928.5 944.886 13077 947.501 13156 937.001C13213.4 929.367 13329.2 909.469 13408 923.001C13454.1 930.917 13494.8 933.111 13606 923.001C13729.5 911.77 13869.7 926.1 13935.5 937.001C14014 950.011 14098.1 956.79 14214 937C14296 923 14386.5 902.025 14494.7 911.77C14619.5 923.001 14736.5 954.501 14942.5 936.001C15035.9 935.334 15100 909.77 15223 924C15290 924 15354.8 962.001 15359 961.501V1080H14942.5H11887V993.5Z",
    fill: "#134B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7543 527.789C7629.36 513.322 7681.29 527.22 7705.03 535.917C7715.18 539.628 7722.06 543.096 7723.93 544.045C7769.89 567.452 7790.71 606.249 7807.64 633.45C7852.41 705.38 7861.75 682.866 7910.25 758.075C7955.51 828.272 7953.43 857.261 7993.96 879.991C8011.08 889.582 8010.54 883.893 8069.57 907.084C8127.01 929.625 8142.19 940.787 8150.58 947.723C8174.24 967.283 8188.2 990.122 8196.49 1007.33C7980.46 1004.62 7764.43 1001.91 7548.4 999.198H7543V527.789Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7543.48 528.672C7503.19 528.671 7439.95 557.107 7420.45 568.849C7410.3 572.56 7372.67 596.603 7371.35 598.048C7351.44 619.727 7323.12 646.164 7312.95 657.331C7244.82 732.1 7197.48 761.299 7169.16 785.632C7123.9 855.828 7133.06 858.144 7092.53 880.874C7075.41 890.465 7075.95 884.775 7016.92 907.967C6959.48 930.508 6944.3 941.67 6935.91 948.605C6912.25 968.166 6898.29 991.005 6890 1008.21C7106.03 1005.5 7322.06 1002.79 7538.08 1000.08H7543.48V528.672Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7543 999.198C7543 999.198 7543 746.343 7543 619.903C7548.16 619.55 7557.1 619.442 7567.31 622.612C7582.54 627.353 7592.04 636.727 7594.31 638.867C7615.94 659.268 7672.89 674.467 7721.23 698.471C7752.44 713.968 7860.7 767.746 7877.85 836.643C7879.98 845.231 7884.84 870.617 7902.15 877.281C7914.28 881.941 7921.08 873.028 7934.55 877.281C7950.97 882.456 7953 899.497 7969.66 920.629C7969.66 920.629 7986.59 942.114 8012.87 955.85C8047.29 973.866 8065.68 960.51 8104.68 974.814C8117.99 979.691 8136.35 988.794 8155.98 1007.33L7543 999.198Z",
    fill: "#0A0019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7543.48 1000.08C7543.48 1000.08 7543.48 747.226 7543.48 620.786C7538.33 620.433 7529.39 620.325 7519.18 623.495C7503.95 628.236 7494.45 637.61 7492.18 639.75C7470.55 660.151 7413.6 675.35 7365.26 699.354C7334.05 714.851 7225.79 768.629 7208.64 837.525C7206.51 846.114 7201.65 871.499 7184.34 878.164C7172.21 882.824 7165.41 873.911 7151.93 878.164C7135.52 883.339 7133.49 900.38 7116.83 921.512C7116.83 921.512 7099.9 942.997 7073.62 956.732C7039.19 974.749 7020.8 961.392 6981.81 975.697C6968.5 980.574 6950.14 989.677 6930.5 1008.21L7543.48 1000.08Z",
    fill: "#0A0019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5896 865C5856 866.2 5759 878.833 5716 882.5V1079.5H7486C7499.67 941.167 7518.8 667.001 7486 677.001C7445 689.501 7111 809 7072 835.5C7033 862 6708 909.5 6638 919.5C6607.64 923.836 6347.5 919.5 6233.5 907.5C6215.1 905.563 5946 863.5 5896 865Z",
    fill: "#134B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7684.29 641C7498.7 643.909 7449.07 693.532 7419.5 734.5C7415.84 739.583 7367.47 769.109 7339.43 809.404C7279.5 862.5 7257.8 879.488 7245.5 889.5C7206.86 921.037 7223.37 907.66 7150.22 944.127C7106.54 965.897 7062.81 996.852 7046.45 1008.43C7039.34 1013.45 7019.57 1027.62 6991.52 1045.17C6978.79 1053.13 6968.14 1059.41 6961 1063.54C7203.1 1061.49 7442.18 1065.59 7684.29 1063.54V641Z",
    fill: "#134B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7600.5 797C7567.85 806.461 7542.21 821.464 7530.31 833.743C7504.28 860.595 7507.58 881.661 7481.48 898.042C7457.8 912.923 7450.48 898.41 7417.39 913.352C7394.78 923.548 7392.25 933.009 7347.2 959.28C7336.95 965.25 7321.48 973.885 7307.53 968.465C7300.42 965.71 7301.06 962.189 7295.32 959.28C7274.9 948.992 7247.9 984.05 7194.61 1002.15C7183.29 1005.97 7173.25 1008.27 7173.25 1008.27C7148.8 1013.81 7141.69 1010.6 7127.47 1014.39C7105.53 1020.24 7107.51 1031.91 7084.74 1041.95C7080.35 1043.88 7073.94 1046.27 7026.76 1048.07C6983.33 1049.76 6973.66 1048.32 6956.57 1054.2C6941.25 1059.46 6929.93 1067.15 6923 1072.57C7148.83 1073.58 7374.67 1074.62 7600.5 1075.63V797Z",
    fill: "#153053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7436.54 1069.5C7434.74 1061.51 7426.62 1030.03 7396.87 1011.32C7391.4 1007.89 7375.75 998.036 7357.19 999.077C7326.61 1000.79 7297.65 1031.59 7287 1075.62H7436.54V1069.5Z",
    fill: "#012257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.5 951.5C732.5 919.9 219.5 904 -5 900V1079.5H1984V900C1928.8 900 1662 934.333 1535.5 951.5C1459.83 964.667 1244.5 983.1 988.5 951.5Z",
    fill: "#134B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2962.5 953.5C2706.5 921.9 2193.5 906 1969 902V1081.5H3958C3958 1071.67 3976.5 1022 3976.5 894C3921.3 894 3636 936.333 3509.5 953.5C3433.83 966.667 3218.5 985.1 2962.5 953.5Z",
    fill: "#134B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-153.995 974.281C50.3156 981.029 191.124 1069.5 207 1080H-974C-768.769 1042.51 -317.444 968.883 -153.995 974.281Z",
    fill: "#153053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.5 987C706.811 993.748 1165.12 1069.5 1181 1080H0C205.231 1042.51 339.051 981.602 502.5 987Z",
    fill: "#153053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2124.65 988.376C1851.49 997.398 1663.23 1115.69 1642 1129.72H3221C2946.61 1079.6 2343.18 981.158 2124.65 988.376Z",
    fill: "#153053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4594.66 915.494C4509.67 887.76 4132 872.5 3951.5 896L3958 1080.07H5954V871.813C5796.2 837.838 5651.71 846.406 5580.89 853.34C5510.06 860.273 5356.34 862.106 5073.66 915.494C4790.98 968.882 4700.89 950.162 4594.66 915.494Z",
    fill: "#134B61"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5442.89 1033.77)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5449.55 1037.47)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5448.46 1044.03)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5440.72 1046.91)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5436.59 1040.52)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 5444.42 1040.25)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4698.05 1043.08C4655.35 1058.12 4312 1062.19 4292 1079H4390.5H5955.5V928C5869.5 930.5 5721.76 964.388 5589.74 967.061C5424.72 970.402 5317 1033.05 5242.5 1024.5C5218.05 1021.69 5095.41 1043.08 4990.46 1033.05C4885.51 1023.03 4740.76 1028.04 4698.05 1043.08Z",
    fill: "#153053"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5832.5,
    cy: 1020,
    r: 3,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5831.5,
    cy: 1024,
    r: 3,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5834.5,
    cy: 1026,
    r: 3,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5838.5,
    cy: 1024,
    r: 3,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5837.5,
    cy: 1020,
    r: 3,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5834.5,
    cy: 1023,
    r: 2,
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5626.5,
    cy: 1006,
    r: 3,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5625.5,
    cy: 1010,
    r: 3,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5628.5,
    cy: 1012,
    r: 3,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5632.5,
    cy: 1010,
    r: 3,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5631.5,
    cy: 1006,
    r: 3,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5628.5,
    cy: 1009,
    r: 2,
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 5368.79 1019)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 5369.79 1023)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 5366.79 1025)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 5362.79 1023)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 5363.79 1019)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 5366.79 1022)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5748.04,
    cy: 994.881,
    r: 5.53846,
    transform: "rotate(36.1252 5748.04 994.881)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5742.19,
    cy: 999.758,
    r: 5.53846,
    transform: "rotate(36.1252 5742.19 999.758)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5744.49,
    cy: 1006.01,
    r: 5.53846,
    transform: "rotate(36.1252 5744.49 1006.01)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5752.63,
    cy: 1007.38,
    r: 5.53846,
    transform: "rotate(36.1252 5752.63 1007.38)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5755.49,
    cy: 1000.32,
    r: 5.53846,
    transform: "rotate(36.1252 5755.49 1000.32)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5747.75,
    cy: 1001.53,
    r: 3.69231,
    transform: "rotate(36.1252 5747.75 1001.53)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5812.26,
    cy: 969.827,
    r: 5.53846,
    transform: "rotate(36.1252 5812.26 969.827)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5806.42,
    cy: 974.704,
    r: 5.53846,
    transform: "rotate(36.1252 5806.42 974.704)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5808.71,
    cy: 980.951,
    r: 5.53846,
    transform: "rotate(36.1252 5808.71 980.951)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5816.86,
    cy: 982.323,
    r: 5.53846,
    transform: "rotate(36.1252 5816.86 982.323)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5819.72,
    cy: 975.269,
    r: 5.53846,
    transform: "rotate(36.1252 5819.72 975.269)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5811.98,
    cy: 976.478,
    r: 3.69231,
    transform: "rotate(36.1252 5811.98 976.478)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5566.88,
    cy: 1032.54,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5565.04,
    cy: 1039.92,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5570.58,
    cy: 1043.62,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5577.96,
    cy: 1039.92,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5576.12,
    cy: 1032.54,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5570.58,
    cy: 1038.08,
    r: 3.69231,
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5425.12 1037.54)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5426.96 1044.92)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5421.42 1048.62)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5414.04 1044.92)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5415.88 1037.54)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-1 0 0 1 5421.42 1043.08)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5525.35,
    cy: 1001.38,
    r: 4.38462,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5523.88,
    cy: 1007.23,
    r: 4.38462,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5528.27,
    cy: 1010.15,
    r: 4.38462,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5534.12,
    cy: 1007.23,
    r: 4.38462,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5532.65,
    cy: 1001.38,
    r: 4.38462,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5528.27,
    cy: 1005.77,
    r: 2.92308,
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 5481.65 1021.38)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 5483.12 1027.23)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 5478.73 1030.15)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 5472.88 1027.23)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 5474.35 1021.38)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.92308,
    transform: "matrix(-1 0 0 1 5478.73 1025.77)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5696.39,
    cy: 1024.92,
    r: 5.53846,
    transform: "rotate(46.9377 5696.39 1024.92)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5689.74,
    cy: 1028.62,
    r: 5.53846,
    transform: "rotate(46.9377 5689.74 1028.62)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5690.82,
    cy: 1035.18,
    r: 5.53846,
    transform: "rotate(46.9377 5690.82 1035.18)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5698.56,
    cy: 1038.06,
    r: 5.53846,
    transform: "rotate(46.9377 5698.56 1038.06)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5702.7,
    cy: 1031.67,
    r: 5.53846,
    transform: "rotate(46.9377 5702.7 1031.67)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5694.87,
    cy: 1031.4,
    r: 3.69231,
    transform: "rotate(46.9377 5694.87 1031.4)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5884.88,
    cy: 985.538,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5883.04,
    cy: 992.923,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5888.58,
    cy: 996.616,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5895.96,
    cy: 992.923,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5894.12,
    cy: 985.538,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5888.58,
    cy: 991.077,
    r: 3.69231,
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5908.88,
    cy: 1028.54,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5907.04,
    cy: 1035.92,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5912.58,
    cy: 1039.62,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5919.96,
    cy: 1035.92,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5918.12,
    cy: 1028.54,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5912.58,
    cy: 1034.08,
    r: 3.69231,
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7211.45 1044.08C7254.15 1059.12 7597.5 1063.19 7617.5 1080H7519H5954V928C6024 928 6187.74 965.388 6319.76 968.061C6484.78 971.402 6592.5 1016.95 6667 1025.5C6697.5 1029 6814.09 1044.08 6919.04 1034.05C7023.99 1024.03 7168.74 1029.04 7211.45 1044.08Z",
    fill: "#153053"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6077 1021)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6078 1025)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6075 1027)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6071 1025)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6072 1021)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 6075 1024)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6283 1007)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6284 1011)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6281 1013)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6277 1011)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 6278 1007)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 6281 1010)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6540.71,
    cy: 1020,
    r: 3,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6539.71,
    cy: 1024,
    r: 3,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6542.71,
    cy: 1026,
    r: 3,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6546.71,
    cy: 1024,
    r: 3,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6545.71,
    cy: 1020,
    r: 3,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6542.71,
    cy: 1023,
    r: 2,
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6161.46 995.881)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6167.31 1000.76)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6165.01 1007.01)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6156.87 1008.38)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6154.01 1001.32)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6161.75 1002.53)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6097.24 970.827)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6103.08 975.704)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6100.79 981.951)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6092.64 983.323)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6089.78 976.269)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-0.807731 0.589551 0.589551 0.807731 6097.52 977.478)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6342.62 1033.54)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6344.46 1040.92)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6338.92 1044.62)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6331.54 1040.92)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6333.38 1033.54)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-1 0 0 1 6338.92 1039.08)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6484.38,
    cy: 1038.54,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6482.54,
    cy: 1045.92,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6488.08,
    cy: 1049.62,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6495.46,
    cy: 1045.92,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6493.62,
    cy: 1038.54,
    r: 5.53846,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6488.08,
    cy: 1044.08,
    r: 3.69231,
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 6384.15 1002.38)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 6385.62 1008.23)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 6381.23 1011.15)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 6375.38 1008.23)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.38462,
    transform: "matrix(-1 0 0 1 6376.85 1002.38)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.92308,
    transform: "matrix(-1 0 0 1 6381.23 1006.77)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6427.85,
    cy: 1022.38,
    r: 4.38462,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6426.38,
    cy: 1028.23,
    r: 4.38462,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6430.77,
    cy: 1031.15,
    r: 4.38462,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6436.62,
    cy: 1028.23,
    r: 4.38462,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6435.15,
    cy: 1022.38,
    r: 4.38462,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6430.77,
    cy: 1026.77,
    r: 2.92308,
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 6213.11 1025.92)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 6219.76 1029.62)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 6218.68 1036.18)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 6210.94 1039.06)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 6206.8 1032.67)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-0.682793 0.730612 0.730612 0.682793 6214.63 1032.4)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6024.62 986.538)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6026.46 993.923)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6020.92 997.616)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6013.54 993.923)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6015.38 986.538)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-1 0 0 1 6020.92 992.077)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6000.62 1029.54)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 6002.46 1036.92)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5996.92 1040.62)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5989.54 1036.92)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.53846,
    transform: "matrix(-1 0 0 1 5991.38 1029.54)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.69231,
    transform: "matrix(-1 0 0 1 5996.92 1035.08)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4249.48 972.228C4230.96 962.009 4208.27 949.498 4166 949.498V949.519L4166 949.5C4113.91 953.946 4097.27 963.695 4082.16 972.545C4077.77 975.114 4073.51 977.608 4068.55 979.874C4030.96 997.047 4004.89 1009.38 3989.21 1038.03C3979.69 1055.42 3977.43 1072.53 3977 1083.95C3998.03 1083.95 4025.73 1084.76 4053.43 1085.57C4108.69 1087.18 4163.95 1088.79 4166.2 1083.98C4170.35 1088.47 4224.56 1086.88 4278.78 1085.3C4306.48 1084.49 4334.19 1083.68 4355.21 1083.68C4354.79 1072.27 4352.53 1055.16 4343.01 1037.77C4327.32 1009.12 4301.26 996.781 4263.66 979.609C4259.03 977.495 4254.41 974.942 4249.48 972.228Z",
    fill: "#0A0019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4338 1073.48C4339.8 1065.49 4347.92 1034.02 4377.67 1015.32C4383.14 1011.89 4398.79 1002.04 4417.35 1003.08C4447.93 1004.79 4476.89 1035.59 4487.54 1079.6H4338V1073.48Z",
    fill: "#012257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12114.1 1045.21C12071.3 1059.35 11728 1063.18 11708 1079H11806.5H13371.5V952.5C13309.3 959.311 13137.8 971.174 13005.7 973.689C12840.7 976.833 12733 1035.78 12658.5 1027.73C12634.1 1025.09 12511.4 1045.21 12406.5 1035.78C12301.5 1026.34 12156.8 1031.06 12114.1 1045.21Z",
    fill: "#153053"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13248.5,
    cy: 1023.49,
    rx: 3,
    ry: 2.82237,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13247.5,
    cy: 1027.26,
    rx: 3,
    ry: 2.82237,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13250.5,
    cy: 1029.14,
    rx: 3,
    ry: 2.82237,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13254.5,
    cy: 1027.26,
    rx: 3,
    ry: 2.82237,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13253.5,
    cy: 1023.49,
    rx: 3,
    ry: 2.82237,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13250.5,
    cy: 1026.32,
    rx: 2,
    ry: 1.88158,
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13042.5,
    cy: 1010.32,
    rx: 3,
    ry: 2.82237,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13041.5,
    cy: 1014.09,
    rx: 3,
    ry: 2.82237,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13044.5,
    cy: 1015.97,
    rx: 3,
    ry: 2.82237,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13048.5,
    cy: 1014.09,
    rx: 3,
    ry: 2.82237,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13047.5,
    cy: 1010.32,
    rx: 3,
    ry: 2.82237,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13044.5,
    cy: 1013.14,
    rx: 2,
    ry: 1.88158,
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3,
    ry: 2.82237,
    transform: "matrix(-1 0 0 1 12784.8 1022.55)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3,
    ry: 2.82237,
    transform: "matrix(-1 0 0 1 12785.8 1026.32)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3,
    ry: 2.82237,
    transform: "matrix(-1 0 0 1 12782.8 1028.2)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3,
    ry: 2.82237,
    transform: "matrix(-1 0 0 1 12778.8 1026.32)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3,
    ry: 2.82237,
    transform: "matrix(-1 0 0 1 12779.8 1022.55)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2,
    ry: 1.88158,
    transform: "matrix(-1 0 0 1 12782.8 1025.37)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(0.824362 0.566064 -0.612978 0.7901 13164 999.863)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(0.824362 0.566064 -0.612978 0.7901 13158.2 1004.45)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(0.824362 0.566064 -0.612978 0.7901 13160.5 1010.33)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(0.824362 0.566064 -0.612978 0.7901 13168.6 1011.62)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(0.824362 0.566064 -0.612978 0.7901 13171.5 1004.98)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.61782,
    ry: 3.5512,
    transform: "matrix(0.824362 0.566064 -0.612978 0.7901 13163.8 1006.12)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(0.824362 0.566064 -0.612978 0.7901 13228.3 976.291)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(0.824362 0.566064 -0.612978 0.7901 13222.4 980.878)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(0.824362 0.566064 -0.612978 0.7901 13224.7 986.754)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(0.824362 0.566064 -0.612978 0.7901 13232.9 988.044)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(0.824362 0.566064 -0.612978 0.7901 13235.7 981.41)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.61782,
    ry: 3.5512,
    transform: "matrix(0.824362 0.566064 -0.612978 0.7901 13228 982.549)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12982.9,
    cy: 1035.29,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12981,
    cy: 1042.24,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12986.6,
    cy: 1045.71,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12994,
    cy: 1042.24,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12992.1,
    cy: 1035.29,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12986.6,
    cy: 1040.5,
    rx: 3.69231,
    ry: 3.47368,
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 12841.1 1039.99)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 12843 1046.94)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 12837.4 1050.42)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 12830 1046.94)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 12831.9 1039.99)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.69231,
    ry: 3.47368,
    transform: "matrix(-1 0 0 1 12837.4 1045.2)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12941.3,
    cy: 1005.98,
    rx: 4.38462,
    ry: 4.125,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12939.9,
    cy: 1011.48,
    rx: 4.38462,
    ry: 4.125,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12944.3,
    cy: 1014.23,
    rx: 4.38462,
    ry: 4.125,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12950.1,
    cy: 1011.48,
    rx: 4.38462,
    ry: 4.125,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12948.7,
    cy: 1005.98,
    rx: 4.38462,
    ry: 4.125,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12944.3,
    cy: 1010.11,
    rx: 2.92308,
    ry: 2.75,
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.38462,
    ry: 4.125,
    transform: "matrix(-1 0 0 1 12897.7 1024.8)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.38462,
    ry: 4.125,
    transform: "matrix(-1 0 0 1 12899.1 1030.3)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.38462,
    ry: 4.125,
    transform: "matrix(-1 0 0 1 12894.7 1033.04)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.38462,
    ry: 4.125,
    transform: "matrix(-1 0 0 1 12888.9 1030.3)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.38462,
    ry: 4.125,
    transform: "matrix(-1 0 0 1 12890.3 1024.8)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.92308,
    ry: 2.75,
    transform: "matrix(-1 0 0 1 12894.7 1028.92)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.36591,
    ry: 5.38806,
    transform: "matrix(0.70475 0.709455 -0.751006 0.660296 13112.4 1028.12)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.36591,
    ry: 5.38806,
    transform: "matrix(0.70475 0.709455 -0.751006 0.660296 13105.7 1031.6)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.36591,
    ry: 5.38806,
    transform: "matrix(0.70475 0.709455 -0.751006 0.660296 13106.8 1037.78)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.36591,
    ry: 5.38806,
    transform: "matrix(0.70475 0.709455 -0.751006 0.660296 13114.6 1040.48)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.36591,
    ry: 5.38806,
    transform: "matrix(0.70475 0.709455 -0.751006 0.660296 13118.7 1034.47)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.57727,
    ry: 3.59204,
    transform: "matrix(0.70475 0.709455 -0.751006 0.660296 13110.9 1034.22)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13300.9,
    cy: 991.071,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13299,
    cy: 998.016,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13304.6,
    cy: 1001.49,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13312,
    cy: 998.016,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13310.1,
    cy: 991.071,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13304.6,
    cy: 996.279,
    rx: 3.69231,
    ry: 3.47368,
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13324.9,
    cy: 1031.53,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13323,
    cy: 1038.47,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13328.6,
    cy: 1041.95,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13336,
    cy: 1038.47,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13334.1,
    cy: 1031.53,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13328.6,
    cy: 1036.73,
    rx: 3.69231,
    ry: 3.47368,
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14694 1027.73C14756.6 1027.73 15013.5 1063.18 15033.5 1079H14935H13370V952.5C13432.2 959.311 13603.7 971.174 13735.8 973.689C13900.8 976.833 14008.9 1016.37 14083 1027.73C14135.5 1035.78 14230.1 1045.21 14335 1035.78C14440 1026.34 14649 1027.73 14694 1027.73Z",
    fill: "#153053"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3,
    ry: 2.82237,
    transform: "matrix(-1 0 0 1 13495.1 1024.43)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3,
    ry: 2.82237,
    transform: "matrix(-1 0 0 1 13496.1 1028.2)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3,
    ry: 2.82237,
    transform: "matrix(-1 0 0 1 13493.1 1030.08)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3,
    ry: 2.82237,
    transform: "matrix(-1 0 0 1 13489.1 1028.2)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3,
    ry: 2.82237,
    transform: "matrix(-1 0 0 1 13490.1 1024.43)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2,
    ry: 1.88158,
    transform: "matrix(-1 0 0 1 13493.1 1027.25)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3,
    ry: 2.82237,
    transform: "matrix(-1 0 0 1 13701.1 1011.26)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3,
    ry: 2.82237,
    transform: "matrix(-1 0 0 1 13702.1 1015.03)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3,
    ry: 2.82237,
    transform: "matrix(-1 0 0 1 13699.1 1016.91)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3,
    ry: 2.82237,
    transform: "matrix(-1 0 0 1 13695.1 1015.03)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3,
    ry: 2.82237,
    transform: "matrix(-1 0 0 1 13696.1 1011.26)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2,
    ry: 1.88158,
    transform: "matrix(-1 0 0 1 13699.1 1014.08)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13958.8,
    cy: 1023.49,
    rx: 3,
    ry: 2.82237,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13957.8,
    cy: 1027.26,
    rx: 3,
    ry: 2.82237,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13960.8,
    cy: 1029.14,
    rx: 3,
    ry: 2.82237,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13964.8,
    cy: 1027.26,
    rx: 3,
    ry: 2.82237,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13963.8,
    cy: 1023.49,
    rx: 3,
    ry: 2.82237,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13960.8,
    cy: 1026.32,
    rx: 2,
    ry: 1.88158,
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(-0.824362 0.566064 0.612978 0.7901 13579.5 1000.8)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(-0.824362 0.566064 0.612978 0.7901 13585.4 1005.39)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(-0.824362 0.566064 0.612978 0.7901 13583.1 1011.27)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(-0.824362 0.566064 0.612978 0.7901 13574.9 1012.56)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(-0.824362 0.566064 0.612978 0.7901 13572.1 1005.92)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.61782,
    ry: 3.5512,
    transform: "matrix(-0.824362 0.566064 0.612978 0.7901 13579.8 1007.06)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(-0.824362 0.566064 0.612978 0.7901 13515.3 977.235)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(-0.824362 0.566064 0.612978 0.7901 13521.1 981.822)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(-0.824362 0.566064 0.612978 0.7901 13518.8 987.698)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(-0.824362 0.566064 0.612978 0.7901 13510.7 988.988)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.42673,
    ry: 5.3268,
    transform: "matrix(-0.824362 0.566064 0.612978 0.7901 13507.8 982.354)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.61782,
    ry: 3.5512,
    transform: "matrix(-0.824362 0.566064 0.612978 0.7901 13515.6 983.492)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 13760.7 1036.23)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 13762.5 1043.18)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 13757 1046.65)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 13749.6 1043.18)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 13751.4 1036.23)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.69231,
    ry: 3.47368,
    transform: "matrix(-1 0 0 1 13757 1041.44)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13902.4,
    cy: 1040.94,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13900.6,
    cy: 1047.88,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13906.1,
    cy: 1051.36,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13913.5,
    cy: 1047.88,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13911.7,
    cy: 1040.94,
    rx: 5.53846,
    ry: 5.21053,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13906.1,
    cy: 1046.14,
    rx: 3.69231,
    ry: 3.47368,
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.38462,
    ry: 4.125,
    transform: "matrix(-1 0 0 1 13802.2 1006.92)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.38462,
    ry: 4.125,
    transform: "matrix(-1 0 0 1 13803.7 1012.42)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.38462,
    ry: 4.125,
    transform: "matrix(-1 0 0 1 13799.3 1015.17)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.38462,
    ry: 4.125,
    transform: "matrix(-1 0 0 1 13793.4 1012.42)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.38462,
    ry: 4.125,
    transform: "matrix(-1 0 0 1 13794.9 1006.92)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.92308,
    ry: 2.75,
    transform: "matrix(-1 0 0 1 13799.3 1011.05)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13845.9,
    cy: 1025.74,
    rx: 4.38462,
    ry: 4.125,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13844.4,
    cy: 1031.24,
    rx: 4.38462,
    ry: 4.125,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13848.8,
    cy: 1033.99,
    rx: 4.38462,
    ry: 4.125,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13854.7,
    cy: 1031.24,
    rx: 4.38462,
    ry: 4.125,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13853.2,
    cy: 1025.74,
    rx: 4.38462,
    ry: 4.125,
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13848.8,
    cy: 1029.86,
    rx: 2.92308,
    ry: 2.75,
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.36591,
    ry: 5.38806,
    transform: "matrix(-0.70475 0.709455 0.751006 0.660296 13631.2 1029.06)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.36591,
    ry: 5.38806,
    transform: "matrix(-0.70475 0.709455 0.751006 0.660296 13637.8 1032.54)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.36591,
    ry: 5.38806,
    transform: "matrix(-0.70475 0.709455 0.751006 0.660296 13636.7 1038.72)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.36591,
    ry: 5.38806,
    transform: "matrix(-0.70475 0.709455 0.751006 0.660296 13629 1041.42)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.36591,
    ry: 5.38806,
    transform: "matrix(-0.70475 0.709455 0.751006 0.660296 13624.9 1035.41)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.57727,
    ry: 3.59204,
    transform: "matrix(-0.70475 0.709455 0.751006 0.660296 13632.7 1035.16)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 13412.6 968.495)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 13414.5 975.44)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 13408.9 978.917)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 13401.5 975.44)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 13403.4 968.495)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.69231,
    ry: 3.47368,
    transform: "matrix(-1 0 0 1 13408.9 973.703)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 13418.7 1032.47)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 13420.5 1039.41)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 13415 1042.89)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 13407.6 1039.41)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.53846,
    ry: 5.21053,
    transform: "matrix(-1 0 0 1 13409.4 1032.47)",
    fill: "#695070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.69231,
    ry: 3.47368,
    transform: "matrix(-1 0 0 1 13415 1037.67)",
    fill: "#8C8146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11754 1062.48C11755.8 1054.49 11763.9 1023.02 11793.7 1004.32C11799.1 1000.89 11814.8 991.036 11833.3 992.077C11863.9 993.791 11892.9 1024.59 11903.5 1068.6H11754V1062.48Z",
    fill: "#012257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9600.38 719.824C9440.33 722.333 9378.48 758.431 9352.97 793.763C9349.82 798.147 9327.15 830.31 9302.97 865.061C9260.67 925.797 9258.3 930.365 9247.69 939C9214.37 966.199 9202.87 949.801 9139.78 981.251C9102.12 1000.03 9064.4 1026.72 9050.29 1036.71C9044.16 1041.04 9027.11 1053.26 9002.92 1068.39C8991.94 1075.26 8982.76 1080.67 8976.6 1084.24C9185.39 1082.47 9391.59 1086.01 9600.38 1084.24V719.824Z",
    fill: "#134B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9600 719.43C9760.05 721.938 9821.9 758.036 9847.41 793.369C9850.57 797.752 9873.23 829.916 9897.42 864.667C9939.71 925.402 9942.08 929.971 9952.69 938.606C9986.01 965.805 9997.51 949.406 10060.6 980.856C10098.3 999.632 10136 1026.33 10150.1 1036.31C10156.2 1040.64 10173.3 1052.87 10197.5 1068C10208.4 1074.86 10217.6 1080.28 10223.8 1083.84C10015 1082.07 9808.8 1085.61 9600 1083.84V719.43Z",
    fill: "#134B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9599.71 842.195C9571.55 850.355 9549.44 863.294 9539.18 873.883C9516.73 897.042 9519.57 915.21 9497.07 929.338C9476.64 942.171 9470.32 929.654 9441.79 942.541C9422.29 951.334 9420.11 959.494 9381.26 982.151C9372.41 987.3 9359.07 994.747 9347.04 990.073C9340.91 987.696 9341.46 984.66 9336.51 982.151C9318.91 973.278 9295.61 1003.51 9249.66 1019.12C9239.89 1022.42 9231.23 1024.4 9231.23 1024.4C9210.15 1029.18 9204.02 1026.41 9191.75 1029.68C9172.83 1034.73 9174.54 1044.79 9154.91 1053.45C9151.12 1055.11 9145.59 1057.17 9104.9 1058.73C9067.44 1060.18 9059.1 1058.94 9044.36 1064.01C9031.15 1068.55 9021.38 1075.18 9015.41 1079.86C9210.18 1080.73 9404.95 1081.63 9599.71 1082.5V842.195Z",
    fill: "#153053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9599.72 963.67C9564.66 970.773 9534.49 981.389 9515.49 990.077C9483.07 1004.89 9460.59 1015.53 9447.06 1040.25C9438.85 1055.25 9436.9 1070.01 9436.53 1079.86C9490.94 1079.86 9545.31 1079.86 9599.72 1079.86V963.67Z",
    fill: "#0A0019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9434.97 1074.8C9433.42 1067.91 9426.41 1040.76 9400.75 1024.63C9396.04 1021.67 9382.54 1013.17 9366.54 1014.07C9340.16 1015.54 9315.19 1042.11 9306 1080.08H9434.97V1074.8Z",
    fill: "#012257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9410.14 858.744C9371.39 857.35 9363.91 868.051 9343.66 865.177C9310.36 860.438 9279.68 824.242 9272.9 785.837C9272.32 782.556 9264.15 732.893 9290.06 710.785C9297.58 704.352 9306.72 701.35 9313.64 689.342C9320.55 677.355 9319.54 666.333 9320.08 659.321C9322.37 629.365 9358.93 595.12 9397.27 588.558C9453.95 578.844 9494.86 632.946 9500.2 640.022C9536.7 688.291 9525.76 744.387 9523.79 753.672C9530.05 756.181 9537.88 760.641 9543.09 768.682C9556.87 789.954 9544.29 823.62 9525.93 841.59C9502.97 864.062 9469.43 863.419 9448.74 863.033C9430.9 862.69 9431.09 859.495 9410.14 858.744Z",
    fill: "#3C7474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9279.33 787.983C9283.04 786.225 9288.12 795.875 9296.49 794.416C9302.26 793.409 9306.44 787.683 9309.35 783.695C9314.54 776.597 9313.79 772.737 9317.93 770.829C9323.14 768.427 9327.13 773.209 9330.8 770.829C9335.3 767.912 9330.6 759.914 9335.09 751.53C9338.73 744.711 9347.54 739.307 9354.38 740.808C9360.77 742.202 9360.8 748.613 9369.39 751.53C9371.07 752.087 9377.05 754.103 9382.26 751.53C9388.84 748.27 9386.87 741.344 9392.98 736.519C9399.63 731.266 9411.23 732.145 9418.71 736.519C9427.87 741.859 9426.67 749.964 9433.72 751.53C9438.91 752.688 9440.91 748.592 9455.17 742.952C9464.07 739.436 9468.51 737.677 9472.32 738.664C9482.1 741.215 9487.83 755.475 9489.48 764.396C9490.7 770.957 9489.33 772.673 9491.62 777.262C9495.55 785.131 9504.04 789.034 9506.63 790.128C9514.01 793.216 9516.86 791.286 9519.5 794.416C9523.72 799.456 9517.68 806.017 9521.64 811.571C9525.39 816.825 9532.69 813.587 9538.8 820.148C9543.09 830.87 9509.68 855.444 9506.63 856.602C9466.62 871.827 9451.78 857.953 9380.12 863.035C9359.21 864.515 9346.56 866.681 9328.65 860.891C9321.94 858.725 9303.13 848.732 9290.05 826.581C9279.83 809.277 9274.36 790.342 9279.33 787.983Z",
    fill: "#3B606C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9282.87 804.255C9285.12 801.982 9289.95 802.261 9293.06 804.255C9296.77 806.635 9295.84 810.109 9299.17 816.65C9300.6 819.48 9305.15 827.414 9313.41 831.102C9317.22 832.818 9320.35 832.946 9325.61 833.161C9334.57 833.547 9336.95 831.617 9345.96 831.102C9353.29 830.673 9359.62 830.287 9366.31 833.161C9374.37 836.613 9373.51 840.709 9382.58 845.555C9386.7 847.742 9394.89 852.117 9402.93 849.694C9411.7 847.035 9411.12 839.058 9419.21 837.299C9424.14 836.227 9429.26 838.65 9439.56 843.497C9447.17 847.078 9448.59 848.922 9453.8 849.694C9456.24 850.058 9462.5 850.98 9468.03 847.635C9474 844.054 9472.3 839.658 9478.22 835.241C9484.18 830.781 9491.62 830.974 9496.53 831.102C9503.42 831.295 9503.91 833.032 9508.73 833.161C9523.1 833.59 9531.79 818.601 9535.2 820.767C9537.98 822.525 9536.97 835.498 9529.08 845.534C9519.73 857.435 9497.63 860.501 9453.77 866.184C9446.48 867.127 9440.84 867.749 9435.46 868.242C9428.06 868.928 9412.39 870.365 9394.76 870.301C9377.22 870.236 9358.63 870.194 9335.73 864.104C9321.68 860.372 9312.55 857.821 9303.16 849.651C9292.41 840.302 9288.25 829.58 9284.84 820.745C9282.42 814.377 9279.78 807.365 9282.87 804.255Z",
    fill: "#3C4D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9474.49 807.579L9421.22 866.377C9418.44 869.443 9413.7 869.679 9410.63 866.891C9407.56 864.104 9407.33 859.365 9410.12 856.298L9463.36 797.501C9466.15 794.434 9470.89 794.198 9473.95 796.986C9477.04 799.752 9477.28 804.513 9474.49 807.579Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9460.92 740.44L9419.4 777.172C9416.29 779.917 9411.55 779.638 9408.81 776.529C9406.06 773.42 9406.34 768.681 9409.45 765.936L9450.97 729.204C9454.08 726.459 9458.82 726.738 9461.56 729.847C9464.33 732.956 9464.03 737.695 9460.92 740.44Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9404.11 830.568L9343.94 770.419C9341 767.482 9341 762.743 9343.94 759.805C9346.88 756.867 9351.62 756.867 9354.56 759.805L9414.73 819.975C9417.66 822.913 9417.66 827.652 9414.73 830.589C9411.79 833.506 9407.03 833.506 9404.11 830.568Z",
    fill: "#293C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9412.28 1041.01C9408.72 1041.01 9405.85 1038.14 9405.85 1034.58V738.658C9405.85 735.098 9408.72 732.225 9412.28 732.225C9415.84 732.225 9418.71 735.098 9418.71 738.658V1034.58C9418.71 1038.14 9415.84 1041.01 9412.28 1041.01Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11643.8 795C11610.2 804.731 11583.8 820.161 11571.6 832.789C11544.8 860.406 11548.2 882.071 11521.4 898.918C11497 914.223 11489.5 899.296 11455.5 914.664C11432.2 925.15 11429.6 934.88 11383.3 961.899C11372.7 968.04 11356.8 976.92 11342.5 971.346C11335.2 968.512 11335.8 964.891 11329.9 961.899C11308.9 951.318 11281.1 987.375 11226.3 1005.99C11214.7 1009.92 11204.4 1012.28 11204.4 1012.28C11179.2 1017.98 11171.9 1014.68 11157.3 1018.58C11134.7 1024.6 11136.8 1036.59 11113.4 1046.92C11108.8 1048.91 11102.2 1051.36 11053.7 1053.22C11009.1 1054.95 10999.1 1053.47 10981.5 1059.52C10965.8 1064.94 10954.1 1072.84 10947 1078.41C11179.3 1079.45 11411.5 1080.52 11643.8 1081.56V795Z",
    fill: "#153053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11643.8 939.858C11602 948.329 11566 960.989 11543.4 971.349C11504.7 989.015 11477.9 1001.71 11461.7 1031.18C11452 1049.07 11449.6 1066.67 11449.2 1078.42C11514.1 1078.42 11578.9 1078.42 11643.8 1078.42V939.858Z",
    fill: "#0A0019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11447.3 1072.39C11445.5 1064.17 11437.1 1031.8 11406.5 1012.55C11400.9 1009.03 11384.8 998.888 11365.7 999.959C11334.3 1001.72 11304.5 1033.4 11293.5 1078.68H11447.3V1072.39Z",
    fill: "#012257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11638.6 795C11672.2 804.731 11698.5 820.161 11710.8 832.789C11737.5 860.406 11734.1 882.071 11761 898.918C11785.3 914.223 11792.9 899.296 11826.9 914.664C11850.2 925.15 11852.8 934.88 11899.1 961.899C11909.6 968.04 11925.5 976.92 11939.9 971.346C11947.2 968.512 11946.5 964.891 11952.4 961.899C11973.4 951.318 12001.2 987.375 12056 1005.99C12067.7 1009.92 12078 1012.28 12078 1012.28C12103.1 1017.98 12110.4 1014.68 12125.1 1018.58C12147.6 1024.6 12145.6 1036.59 12169 1046.92C12173.5 1048.91 12180.1 1051.36 12228.7 1053.22C12273.3 1054.95 12283.3 1053.47 12300.8 1059.52C12316.6 1064.94 12328.2 1072.84 12335.4 1078.41C12103.1 1079.45 11870.8 1080.52 11638.6 1081.56V795Z",
    fill: "#153053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11638.6 940.859C11680.4 949.33 11716.3 961.989 11739 972.35C11777.7 990.016 11804.5 1002.71 11820.6 1032.18C11830.4 1050.07 11832.7 1067.67 11833.2 1079.42C11768.3 1079.42 11703.4 1079.42 11638.6 1079.42V940.859Z",
    fill: "#0A0019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11835 1072.39C11836.9 1064.17 11845.2 1031.8 11875.8 1012.55C11881.5 1009.03 11897.6 998.888 11916.6 999.959C11948.1 1001.72 11977.9 1033.4 11988.8 1078.68H11835V1072.39Z",
    fill: "#012257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9599.67 841.801C9627.83 849.96 9649.94 862.9 9660.21 873.489C9682.66 896.648 9679.81 914.815 9702.32 928.943C9722.74 941.777 9729.06 929.26 9757.59 942.146C9777.09 950.94 9779.28 959.099 9818.12 981.756C9826.97 986.906 9840.31 994.352 9852.34 989.678C9858.47 987.302 9857.92 984.265 9862.87 981.756C9880.48 972.884 9903.77 1003.12 9949.72 1018.73C9959.49 1022.03 9968.15 1024.01 9968.15 1024.01C9989.23 1028.79 9995.36 1026.01 10007.6 1029.29C10026.6 1034.33 10024.8 1044.39 10044.5 1053.05C10048.3 1054.72 10053.8 1056.78 10094.5 1058.34C10131.9 1059.79 10140.3 1058.55 10155 1063.62C10168.2 1068.16 10178 1074.79 10184 1079.46C9989.2 1080.33 9794.44 1081.23 9599.67 1082.1V841.801Z",
    fill: "#153053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9599.67 963.275C9634.73 970.379 9664.89 980.994 9683.89 989.682C9716.32 1004.5 9738.79 1015.14 9752.32 1039.86C9760.53 1054.85 9762.48 1069.62 9762.85 1079.47C9708.45 1079.47 9654.07 1079.47 9599.67 1079.47V963.275Z",
    fill: "#0A0019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9764.41 1074.41C9765.97 1067.51 9772.97 1040.37 9798.63 1024.23C9803.34 1021.28 9816.84 1012.77 9832.85 1013.67C9859.22 1015.15 9884.2 1041.72 9893.38 1079.69H9764.41V1074.41Z",
    fill: "#012257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7589.02 709.016C7753.22 711.589 7816.68 748.625 7842.85 784.875C7846.09 789.372 7869.34 822.371 7894.16 858.024C7937.55 920.337 7939.98 925.024 7950.86 933.883C7985.05 961.789 7996.85 944.964 8061.58 977.231C8100.22 996.494 8138.92 1023.88 8153.39 1034.13C8159.68 1038.57 8177.18 1051.11 8202 1066.64C8213.26 1073.68 8222.68 1079.23 8229 1082.89C8014.78 1081.08 7803.23 1084.71 7589.02 1082.89V709.016Z",
    fill: "#134B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7589.02 839.059C7617.91 847.43 7640.59 860.705 7651.12 871.57C7674.16 895.33 7671.24 913.969 7694.33 928.464C7715.28 941.631 7721.77 928.789 7751.04 942.01C7771.05 951.032 7773.29 959.403 7813.15 982.649C7822.22 987.932 7835.91 995.572 7848.25 990.777C7854.54 988.338 7853.98 985.223 7859.05 982.649C7877.12 973.546 7901.02 1004.57 7948.16 1020.58C7958.18 1023.96 7967.07 1026 7967.07 1026C7988.7 1030.9 7994.99 1028.06 8007.57 1031.42C8026.99 1036.59 8025.23 1046.91 8045.38 1055.8C8049.26 1057.51 8054.94 1059.62 8096.68 1061.22C8135.11 1062.71 8143.67 1061.43 8158.79 1066.64C8172.35 1071.3 8182.36 1078.1 8188.49 1082.89C7988.67 1083.79 7788.84 1084.71 7589.02 1085.6V839.059Z",
    fill: "#153053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7589.02 968.688C7624.99 975.976 7655.93 986.868 7675.43 995.781C7708.7 1010.98 7731.76 1021.9 7745.64 1047.26C7754.06 1062.65 7756.06 1077.79 7756.44 1087.9C7700.62 1087.9 7644.83 1087.9 7589.02 1087.9V968.688Z",
    fill: "#0A0019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7761.84 1077.48C7763.43 1070.41 7770.61 1042.56 7796.94 1026C7801.78 1022.97 7815.63 1014.25 7832.05 1015.17C7859.11 1016.68 7884.73 1043.94 7894.16 1082.9H7761.84V1077.48Z",
    fill: "#012257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7570.24 895.169C7595.95 889.992 7601.79 895.941 7617.3 892.415C7638.39 887.623 7656.22 870.108 7664.35 851.104C7671.72 833.892 7675.62 804.864 7661.59 793.269C7648.24 782.253 7630.8 796.905 7614.53 785.007C7600.55 774.789 7607.66 759.752 7595.15 746.45C7578.32 728.549 7540.65 729.43 7514.87 743.696C7477.62 764.324 7473.96 808.031 7473.35 815.302C7471.08 842.347 7479.5 882.198 7506.57 895.169C7521.93 902.55 7542.58 900.925 7545.32 900.678C7555.51 899.796 7557.84 897.676 7570.24 895.169Z",
    fill: "#FF5E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7785.63 809.905C7756.21 808.393 7750.92 815.121 7741.76 809.905C7726.21 801.056 7732.4 776.436 7717.38 770.903C7710.41 768.344 7706.76 772.804 7697.88 773.341C7675.87 774.681 7649.94 750.086 7641.82 722.151C7633.31 692.851 7644.79 661.186 7666.2 644.147C7675.19 636.981 7684.43 633.617 7690.57 631.959C7680.58 595.566 7691.96 576.26 7695.45 571.019C7710.51 548.422 7741.56 542.84 7788.07 534.455C7801.79 531.993 7807.08 531.944 7810.01 532.017C7812.59 532.066 7857.15 533.699 7875.82 563.706C7888.49 584.085 7883.42 608.168 7892.88 610.021C7896.98 610.825 7898.27 606.389 7905.07 605.146C7918.13 602.757 7936.02 615.018 7939.19 629.522C7941.97 642.27 7932.39 652.216 7936.75 656.335C7940.51 659.894 7948.04 652.85 7956.25 653.898C7975.27 656.311 7998.25 702.162 7983.07 739.214C7974.8 759.373 7954.08 779.752 7931.88 780.653C7915.35 781.312 7903.22 770.952 7892.88 778.216C7885.98 783.067 7889.27 789.161 7883.13 797.717C7868.9 817.559 7830.02 814.244 7807.57 812.342C7796.75 811.416 7796.43 810.441 7785.63 809.905Z",
    fill: "#3C7474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7646.7 724.588C7642.8 734.216 7654.01 748.964 7668.63 761.152C7688.55 777.752 7707.63 773.34 7714.95 770.902C7726.62 767.002 7729.45 795.083 7736.88 805.029C7746.36 817.753 7750.87 807.856 7817.32 812.342C7856.46 814.999 7867.75 816.144 7875.82 807.466C7885.08 797.521 7884.96 780.214 7895.32 778.215C7899.02 777.508 7901.7 779.214 7905.07 780.653C7924.54 788.989 7954.4 782.846 7958.69 770.902C7961.59 762.809 7953.72 749.476 7944.07 746.526C7933.59 743.333 7925.01 753.668 7917.26 748.964C7912.6 746.136 7914.48 741.675 7909.94 734.338C7901.46 720.663 7880.4 712.887 7870.94 719.712C7868.02 721.809 7869.14 725.465 7866.07 727.025C7860.95 729.633 7852.91 723.344 7851.44 722.15C7839.99 712.887 7843.2 702.527 7834.38 690.461C7824.95 677.517 7809.96 673.934 7807.57 673.398C7786.83 668.718 7762.16 679.516 7758.82 692.899C7757.45 698.359 7759.97 703.064 7756.38 709.962C7753.73 715.057 7749.39 717.884 7746.63 719.712C7744.66 721.029 7738.15 725.392 7730.79 725.806C7718.99 726.489 7717.07 716.324 7701.54 711.181C7688.96 707.012 7677.58 709.499 7669.85 711.181C7658.59 713.618 7649.33 718.079 7646.7 724.588Z",
    fill: "#3B606C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7875.84 761.469L7815.3 828.308C7812.13 831.794 7806.74 832.062 7803.25 828.893C7799.77 825.724 7799.5 820.337 7802.67 816.851L7863.22 750.012C7866.38 746.526 7871.77 746.258 7875.26 749.427C7878.74 752.596 7879.01 757.983 7875.84 761.469Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7860.41 685.171L7813.22 726.928C7809.69 730.048 7804.3 729.731 7801.18 726.196C7798.06 722.662 7798.38 717.275 7801.91 714.155L7849.1 672.398C7852.64 669.278 7858.02 669.595 7861.14 673.13C7864.29 676.664 7863.95 682.051 7860.41 685.171Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7795.85 787.626L7727.45 719.227C7724.11 715.888 7724.11 710.5 7727.45 707.161C7730.79 703.821 7736.18 703.821 7739.52 707.161L7807.91 775.56C7811.25 778.9 7811.25 784.287 7807.91 787.626C7804.57 790.942 7799.16 790.942 7795.85 787.626Z",
    fill: "#293C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7805.13 1026.85C7801.09 1026.85 7797.82 1023.59 7797.82 1019.54V683.152C7797.82 679.105 7801.09 675.839 7805.13 675.839C7809.18 675.839 7812.45 679.105 7812.45 683.152V1019.54C7812.45 1023.56 7809.15 1026.85 7805.13 1026.85Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8068.04 958.694C8045.57 954.17 8040.47 959.367 8026.92 956.287C8008.49 952.1 7992.92 936.796 7985.81 920.192C7979.37 905.153 7975.96 879.79 7988.23 869.659C7999.88 860.034 8015.12 872.836 8029.34 862.44C8041.56 853.513 8035.34 840.374 8046.27 828.752C8060.98 813.111 8093.9 813.881 8116.41 826.345C8148.97 844.369 8152.16 882.557 8152.69 888.91C8154.68 912.54 8147.32 947.36 8123.67 958.694C8110.24 965.143 8092.2 963.723 8089.81 963.506C8080.91 962.736 8078.88 960.883 8068.04 958.694Z",
    fill: "#FF5E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8105.91 920.519L8075.85 953.697C8074.28 955.427 8071.6 955.56 8069.87 953.987C8068.14 952.414 8068.01 949.74 8069.58 948.01L8099.63 914.832C8101.2 913.102 8103.87 912.969 8105.6 914.542C8107.35 916.103 8107.48 918.789 8105.91 920.519Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8066.2 933.494L8032.24 899.554C8030.59 897.896 8030.59 895.222 8032.24 893.565C8033.9 891.907 8036.57 891.907 8038.23 893.565L8072.18 927.517C8073.84 929.174 8073.84 931.848 8072.18 933.506C8070.53 935.152 8067.84 935.152 8066.2 933.494Z",
    fill: "#293C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8070.81 1052.24C8068.8 1052.24 8067.18 1050.62 8067.18 1048.61V881.63C8067.18 879.621 8068.8 878 8070.81 878C8072.82 878 8074.44 879.621 8074.44 881.63V1048.61C8074.44 1050.62 8072.82 1052.24 8070.81 1052.24Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9163.76 952.823C9152.47 948.371 9145.03 956.205 9136.12 954.964C9117.43 952.352 9109.32 912.131 9108.47 907.872C9104.69 889.12 9103.16 854.721 9119.11 845.795C9124.21 842.948 9130.36 843.098 9133.99 837.233C9137.73 831.175 9133.86 826.658 9136.12 820.108C9140.07 808.613 9159.4 801.036 9174.4 805.124C9180.07 806.666 9185.47 809.983 9195.66 822.249C9211.52 841.321 9221.18 852.923 9225.43 871.482C9232.15 900.743 9222.69 935.142 9202.04 950.683C9198.38 953.444 9185.67 962.991 9174.4 959.245C9169.57 957.64 9169.23 954.985 9163.76 952.823Z",
    fill: "#FF5E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9764.79 998.819C9753.5 994.367 9746.06 1002.2 9737.15 1000.96C9718.46 998.349 9710.36 958.127 9709.5 953.868C9705.72 935.116 9704.19 900.717 9720.14 891.791C9725.24 888.944 9731.39 889.094 9735.02 883.229C9738.77 877.171 9734.9 872.655 9737.15 866.104C9741.1 854.61 9760.43 847.032 9775.43 851.12C9781.1 852.662 9786.51 855.98 9796.69 868.245C9812.56 887.317 9822.21 898.919 9826.46 917.478C9833.18 946.74 9823.72 981.138 9803.07 996.679C9799.41 999.44 9786.7 1008.99 9775.43 1005.24C9770.6 1003.64 9770.26 1000.98 9764.79 998.819Z",
    fill: "#FF5E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9195 924.98L9169.07 953.594C9167.72 955.086 9165.41 955.201 9163.92 953.844C9162.43 952.488 9162.31 950.182 9163.67 948.689L9189.58 920.076C9190.94 918.584 9193.24 918.469 9194.73 919.825C9196.24 921.172 9196.35 923.488 9195 924.98Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9160.75 936.17L9131.47 906.899C9130.04 905.469 9130.04 903.163 9131.47 901.733C9132.9 900.304 9135.2 900.304 9136.63 901.733L9165.91 931.015C9167.34 932.444 9167.34 934.751 9165.91 936.18C9164.48 937.599 9162.17 937.599 9160.75 936.17Z",
    fill: "#293C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9164.73 1038.58C9162.99 1038.58 9161.6 1037.18 9161.6 1035.45V891.439C9161.6 889.707 9162.99 888.309 9164.73 888.309C9166.46 888.309 9167.86 889.707 9167.86 891.439V1035.45C9167.86 1037.18 9166.46 1038.58 9164.73 1038.58Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9794.03 965.977L9768.11 994.59C9766.75 996.082 9764.44 996.197 9762.95 994.84C9761.46 993.484 9761.34 991.178 9762.7 989.685L9788.61 961.072C9789.97 959.58 9792.27 959.465 9793.77 960.821C9795.27 962.168 9795.38 964.484 9794.03 965.977Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9759.78 977.166L9730.5 947.895C9729.07 946.465 9729.07 944.159 9730.5 942.729C9731.93 941.3 9734.23 941.3 9735.66 942.729L9764.94 972.011C9766.37 973.44 9766.37 975.747 9764.94 977.176C9763.52 978.596 9761.2 978.596 9759.78 977.166Z",
    fill: "#293C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9763.76 1079.57C9762.02 1079.57 9760.63 1078.17 9760.63 1076.44V932.435C9760.63 930.703 9762.02 929.305 9763.76 929.305C9765.49 929.305 9766.89 930.703 9766.89 932.435V1076.44C9766.89 1078.17 9765.49 1079.57 9763.76 1079.57Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17065.5 984.951C17091.8 976.179 17354.5 945 17442.5 945L17446 1106L16406 1118V1099.72C16418.9 1098.02 16449.3 1091.83 16467.4 1080.72C16490.1 1066.83 16545.7 1055.86 16580 1055.86C16614.4 1055.86 16696.3 1050.74 16753.3 1030.28C16810.3 1009.81 16891.5 1011.27 16938.3 1009.81C16985.1 1008.34 17032.6 995.917 17065.5 984.951Z",
    fill: "#134B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18429.5 964.5C18685.5 932.9 18975.5 904 19200 900V1083L17434 1092.5C17434 1082.67 17438.5 1073 17438.5 945C17506.5 939 17756 947.333 17882.5 964.5C17958.2 977.667 18173.5 996.1 18429.5 964.5Z",
    fill: "#134B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19111 987.281C19315.3 994.029 19456.1 1082.5 19472 1093H18291C18496.2 1055.51 18947.6 981.883 19111 987.281Z",
    fill: "#153053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15918.2 1045.11C15916 1035.37 15874.7 1023.58 15847.1 999.527C15840.5 995.349 15797.4 989.919 15774.9 991.187C15737.9 993.276 15691.9 1000.5 15679 1054.14L15936 1101L15918.2 1045.11Z",
    fill: "#012257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15932.6 1059.17C15915.5 1037.4 15893.7 1064.24 15885 1080.38L15922.5 1088H15961C15961 1080.38 15949.8 1080.93 15932.6 1059.17Z",
    fill: "#04193C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15509.5 1013.5C15491.5 1007.5 15399.7 975 15356 959.5L15350.5 1104.5H15960.5V1092C15951.7 1090.83 15930.9 1086.6 15918.5 1079C15903 1069.5 15865 1062 15841.5 1062C15818 1062 15762 1058.5 15723 1044.5C15684 1030.5 15628.5 1031.5 15596.5 1030.5C15564.5 1029.5 15532 1021 15509.5 1013.5Z",
    fill: "#134B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16879 1074C16877 1065.03 16856 1033 16830.4 1010.83C16824.3 1006.98 16806.7 995.918 16785.9 997.086C16751.5 999.01 16719 1033.58 16707 1083L16916.5 1126.5L16879 1074Z",
    fill: "#012257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7590.5 970C7551.5 971.5 7526.85 984.699 7507.87 993.377C7475.48 1008.17 7453.03 1018.8 7439.52 1043.49C7431.31 1058.47 7429.37 1073.22 7429 1083.06C7483.34 1083.06 7537.66 1083.06 7592 1083.06L7590.5 970Z",
    fill: "#0A0019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7554.09 856.519L7584.15 889.697C7585.72 891.427 7588.4 891.56 7590.13 889.987C7591.86 888.414 7591.99 885.74 7590.42 884.01L7560.37 850.832C7558.8 849.102 7556.13 848.969 7554.4 850.542C7552.65 852.103 7552.52 854.789 7554.09 856.519Z",
    fill: "#001A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7593.8 869.494L7627.76 835.554C7629.41 833.896 7629.41 831.222 7627.76 829.565C7626.1 827.907 7623.43 827.907 7621.77 829.565L7587.82 863.517C7586.16 865.174 7586.16 867.848 7587.82 869.506C7589.47 871.152 7592.16 871.152 7593.8 869.494Z",
    fill: "#293C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7589.19 988.237C7591.2 988.237 7592.82 986.616 7592.82 984.607V817.63C7592.82 815.621 7591.2 814 7589.19 814C7587.18 814 7585.56 815.621 7585.56 817.63V984.607C7585.56 986.616 7587.18 988.237 7589.19 988.237Z",
    fill: "#001A4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8658,
    y1: 649.181,
    x2: 8658,
    y2: 1222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#35359F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823923,
    stopColor: "#05ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872917,
    stopColor: "#00718F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 10872,
    y1: 607.181,
    x2: 10872,
    y2: 1180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#35359F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823923,
    stopColor: "#05ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872917,
    stopColor: "#00718F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 16275,
    y1: 771.346,
    x2: 16275,
    y2: 1216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.602083,
    stopColor: "#069FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794792,
    stopColor: "#00718F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19200,
    height: 1080,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrassAndTrees);
export default __webpack_public_path__ + "static/media/GrassAndTrees.06fb2040.svg";
export { ForwardRef as ReactComponent };